import type { EmailAuthCandidatesResponse } from "@Front/Api/Public/emailAuthCandidatesApi";
import type { CustomerLoginMulticandidateDecision } from "@Front/Components/Layouts/Login/helpers/loginCustomerMultiCandidateRouting";
import { decideCustomerLoginMultipleCandidatesFromEmailStep } from "@Front/Components/Layouts/Login/helpers/loginCustomerMultiCandidateRouting";

export function buildActorFlowMulticandidateDecision(
	snap: EmailAuthCandidatesResponse,
	invitationScopeFromRouter: boolean,
): CustomerLoginMulticandidateDecision {
	let decision = decideCustomerLoginMultipleCandidatesFromEmailStep(snap.customerCandidates, invitationScopeFromRouter);
	if (decision.kind === "mail_verify") {
		decision = {
			kind: "mail_verify",
			disambiguation: { ...decision.disambiguation, loginActor: "CUSTOMER" },
		};
	}
	return decision;
}
